import { render, staticRenderFns } from "./GreetingProof.vue?vue&type=template&id=38e92664&"
import script from "./GreetingProof.vue?vue&type=script&lang=js&"
export * from "./GreetingProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports